(() => {
  if (customElements.get('product-personalization')) return;

  class ProductPersonalization extends HTMLElement {
    connectedCallback() {
      this.fieldsContainer = this.querySelector('[data-personalization-fields]');
      this.formId = this.dataset.formId;
      this.prompt = this.dataset.prompt || 'Personalization';
      this.placeholder = this.dataset.placeholder || '';
      this.propertyName = this.dataset.propertyName || 'Personalization';
      this.maxlength = Number.parseInt(this.dataset.maxlength, 10) || 20;
      this.boundRenderFields = this.renderFields.bind(this);
      this.boundHandleQuantityClick = this.handleQuantityClick.bind(this);
      this.quantityInput = null;
      this.lastQuantity = null;

      if (!this.fieldsContainer) return;

      this.bindQuantityInput();
      this.renderFields();
      this.quantityWatcher = window.setInterval(() => {
        this.bindQuantityInput();
        this.renderFieldsIfQuantityChanged();
      }, 250);
      document.addEventListener('click', this.boundHandleQuantityClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.boundHandleQuantityClick);
      this.quantityInput?.removeEventListener('change', this.boundRenderFields);
      this.quantityInput?.removeEventListener('input', this.boundRenderFields);
      window.clearInterval(this.quantityWatcher);
    }

    getQuantityInput() {
      const formQuantityInput = document.getElementById(this.formId)?.elements?.quantity;

      if (formQuantityInput?.matches?.('input[name="quantity"]')) return formQuantityInput;

      return Array.from(document.querySelectorAll('input[name="quantity"]')).find(
        (input) => input.getAttribute('form') === this.formId
      );
    }

    bindQuantityInput() {
      const quantityInput = this.getQuantityInput();

      if (!quantityInput || quantityInput === this.quantityInput) return;

      this.quantityInput?.removeEventListener('change', this.boundRenderFields);
      this.quantityInput?.removeEventListener('input', this.boundRenderFields);
      this.quantityInput = quantityInput;
      quantityInput.addEventListener('change', this.boundRenderFields);
      quantityInput.addEventListener('input', this.boundRenderFields);
    }

    handleQuantityClick(event) {
      const quantityButton = event.target.closest('quantity-input button[name="plus"], quantity-input button[name="minus"]');
      const quantityInput = quantityButton?.closest('quantity-input')?.querySelector('input[name="quantity"]');

      if (quantityInput === this.getQuantityInput()) {
        window.requestAnimationFrame(this.boundRenderFields);
        window.setTimeout(this.boundRenderFields, 50);
      }
    }

    getQuantity() {
      const quantityInput = this.getQuantityInput();
      if (!quantityInput) return 1;

      const quantity = Number.parseInt(quantityInput.value, 10);
      const min = Number.parseInt(quantityInput.getAttribute('min'), 10) || 1;
      const max = Number.parseInt(quantityInput.getAttribute('max'), 10);
      const safeQuantity = Number.isFinite(quantity) ? quantity : min;

      if (Number.isFinite(max)) return Math.min(Math.max(safeQuantity, min), max);

      return Math.max(safeQuantity, min);
    }

    renderFieldsIfQuantityChanged() {
      if (this.getQuantity() !== this.lastQuantity) this.renderFields();
    }

    getExistingValues() {
      return Array.from(this.fieldsContainer.querySelectorAll('input')).map((input) => input.value);
    }

    renderFields() {
      const quantity = this.getQuantity();
      this.lastQuantity = quantity;
      const existingValues = this.getExistingValues();
      const fragment = document.createDocumentFragment();

      for (let index = 1; index <= quantity; index += 1) {
        const fieldGroup = document.createElement('div');
        fieldGroup.className = 'product-personalization__field';

        const label = document.createElement('label');
        label.className = 'product-personalization__label';
        label.setAttribute('for', `${this.formId}-personalization-${index}`);
        label.textContent = `${this.prompt} ${index}`;

        const input = document.createElement('input');
        input.type = 'text';
        input.id = `${this.formId}-personalization-${index}`;
        input.name = `properties[${this.propertyName} ${index}]`;
        input.className = 'product-personalization__input';
        input.maxLength = this.maxlength;
        input.placeholder = this.placeholder;
        input.required = true;
        input.value = existingValues[index - 1] || '';

        fieldGroup.append(label, input);
        fragment.append(fieldGroup);
      }

      this.fieldsContainer.replaceChildren(fragment);
    }
  }

  customElements.define('product-personalization', ProductPersonalization);
})();
